<template>
  <section class="news-container">
    <el-tabs
      v-model="activeTab"
      @tab-click="handleTab">
      <el-tab-pane
        v-for="(tab, index) in tabList"
        :key="index"
        :label="tab.label"
        :name="String(tab.name)"
      ></el-tab-pane>
    </el-tabs>
    <div class="content-container">
      <div class="filter-container">
        <div class="filter-list">
          <v-date-picker
            v-model="date"
            :format="'dd-MM-yyyy'"
            :valueFormat="'yyyy-MM-dd'"
            type="datetimerange"
            @change="filterData"/>
          <!--          <v-date-picker-->
          <!--            v-model="date"-->
          <!--            type="daterange"-->
          <!--            @change="filterData"></v-date-picker>-->
          <v-input
            v-model="coupon_code"
            class="margint-left"
            placeholder="Code"
            @keyEnter="filterData"
            @blur="filterData"></v-input>
        </div>
      </div>

      <div class="transparent">
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-row-class-name="headerClass"
        >
          <el-table-column
            width="95px"
            label="Created">
            <template #default="{ row }">
              <div class="time-text">
                <span>{{ row.created_date }}</span>
                <span> {{ row.created_time }}</span>
              </div>
            </template>

          </el-table-column>
          <el-table-column
            label="Code"
          >
            <template slot-scope="scope">
              <p>{{scope.row.campaign_code}}</p>
              <a
                class="blue fw-600"
                target="_blank"
                :href="scope.row.url"><font-awesome-icon
                  icon="link"
                  class="mg-r-4"></font-awesome-icon>Link</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="times_used"
            label="Used"
          >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>{{scope.row.used_num}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Status" >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>{{scope.row.status_language}}</p>
                <p></p>
              </div>
            </template>
          </el-table-column>


          <el-table-column
            prop="start_time"
            label="From"
          >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>
                  {{scope.row.from}}
                </p>
                <p>
                </p>
              </div>
            </template>
            <template >
            </template>
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="To"
          >
            <template slot-scope="scope">
              <div class="flex-algin">
                <p>
                  {{scope.row.to}}
                </p>
                <p>
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"
    />

  </section>
</template>
<script>
import {getCampaignCodeList} from '@/api/campaign'
import MixinOptions from '@/mixins/options'

export default {
  name: 'CampaingnCodeContainer',
  mixins: [MixinOptions],
  props:{
    headerClass:{
      type:Function,
      default:()=>{
        return 'headerClass'
      }
    }
  },
  data() {
    return {
      pageConfig: {
        //  分頁配置
        size:20,
        currentPage: 1,
        total: 10
      },
      activeTab: '1',
      coupon_code:'',
      tabList: [
        {
          name: '1',
          label: 'Current'
        },
      ],
      status:'',
      tableData: [],
      date:''
    }
  },
  computed: {
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        // this.handleTab()
      }
    },
    getActiveTab:{
      immediate: true,
      handler(val){

      }
    }
  },
  mounted(){
    this.handleTab()
  },
  methods: {
    handlerTitle(title) {
      return title['en-US']
    },
    handlerTime(time) {
      return time = time ? time.split(' ') : ['-', '-']
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCampaignCodeList()
    },
    handleTab() {
      this.pageConfig.currentPage = 1
      this.network().getCampaignCodeList()
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCampaignCodeList()
    },
    handlerRowClick({code, id}) {
      // let path = this.activeTab!=6?'/administration/coupon/detail':'/administration/sme/coupon/detail'
      // this.$router.push({
      //   path: path,
      //   query: {
      //     code: code,
      //     cid:id
      //   }
      // })
    },
    network() {
      return {
        getCampaignCodeList: async (params = {}) => {
          // status
          // 1-current 2-upcoming 3-past
          const {data} = await getCampaignCodeList({
            page: this.pageConfig.currentPage,
            size: this.pageConfig.size,
            created_start: this.date ? this.date[0] : '',
            created_end: this.date ? this.date[1] : '',
            code: this.coupon_code
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        },
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.news-container {
  .margint-left{
    margin-left: 30px;
  }
  .mg-r-4{
    margin-right: 4px;
  }
  .time-text{
    font-size: 12px;
  }
  a{
    text-decoration: none;
  }
  .long-title{
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .content-container {
    position: relative;
    .el-table {
      margin-top: 15px;
      border:1px solid #E1E4E8;
      border-radius: 4px;
      ::v-deep .headerClass{
        background:#F6F8FA;
        th{
          background:#F6F8FA;
          .cell{
            padding: 16px;
            font-size: 14px;
            color: #24292E;
          }
        }
      }
    }

    .btn-list {
      text-align: center;
      span {
        margin-right: 10px;
      }
    }
    .filter-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .filter-list {
        display: flex;
        .el-select {
          margin-right: 15px;
          width: 130px;
        }
      }
    }
  }
  .dialog-container {
    padding: 15px;
  }
  .ic-order {
    .svg-inline--fa {
      color: #91939A;
      font-size: 12px;
    }
  }
  .img-banner {
    width: 150px;
  }
  ::v-deep .flex-algin{
    display: flex;
    flex-direction: column;
    justify-content:space-between ;
    p{
      height: 24px;
    }
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
    /deep/.cell{
      padding-left: 16px;
    }
  }
}
</style>
